import { Event } from '../Event'
import { Identity } from '../../constants'

export interface LeadViewedEventProperties {
  lead_id: string
  suggested_actions: string[]
  labels: string[]
}

export class LeadViewedEvent extends Event<LeadViewedEventProperties> {
  static displayName = 'Lead Viewed'

  static allowedIdentities = [Identity.BusinessUser]
}
